module.exports = __webpack_public_path__ + "img/38_65.c6849e1e.png";